module.exports = __webpack_public_path__ + "img/banner_about_us.dff573bb.png";